import { assertUnreachable } from '../../utils/tsUtils';
function getPartsStr(outbound) {
    if (!outbound.parts) {
        return '';
    }
    const partStrs = outbound.parts.map((part) => {
        if ('stringValue' in part) {
            // string
            // TODO: Determine if we need to encode like we decode (see urlDecode() implementation)
            return part.needsEncoding ? encodeURIComponent(part.stringValue) : part.stringValue;
        }
        if ('booleanValue' in part) {
            // boolean
            return part.booleanValue ? '1' : '0';
        }
        if ('numberValue' in part) {
            // number
            if (part.numberValue === null) {
                // if this field supports it, null number becomes an empty string and server applies its default
                return '';
            }
            return `${part.numberValue}`;
        }
        assertUnreachable(part);
        return ''; // should never be hit but seems to be required to avoid a compiler error
    });
    return partStrs.join(',');
}
export function getOutboundMessage(outbound) {
    return `${outbound._type}:${getPartsStr(outbound)}`;
}
